import { RouteConfig } from 'vue-router'

const route: RouteConfig[] = [
  {
    path: '/elibrary',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('components/ELibrary/Index.vue')
      }
    ],
    meta: { requiresAuth: true }
  }
]

export default route
